import {
  faArrowUpRightFromSquare,
  faDownload,
  faFolderOpen,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import { getUserDetails } from "../../../redux/Actions/userAction";
import { useSelector, useDispatch } from "react-redux";
import Attendants from "../Attendants/Attendants";
import axios from "axios";
import { message } from "antd";
import { BACKEND_URL, FRONTEND_URL } from "../../../config";
import QrCodeCard from "./components/QrCodeCard";
import {
  ONBOARD_YOUR_HOTEL_B2B,
  ONBOARD_YOUR_HOTEL_B2C,
  ONBOARD_YOUR_TEAM_B2B,
  ONBOARD_YOUR_TEAM_B2C,
  STARTER_GUIDE_ATTENDANTS_B2B,
  STARTER_GUIDE_ATTENDANTS_B2C,
  STARTER_GUIDE_BELLMEN_B2B,
  STARTER_GUIDE_BELLMEN_B2C,
  STARTER_GUIDE_VALET_B2B,
  STARTER_GUIDE_VALET_B2C,
} from "../../../constants";

const Documents = () => {
  const [permissions, setPermissions] = useState({
    viewAttendants: false,
    viewValets: false,
    viewBellmans: false,
    viewAirbnb: false,
  });
  const SERVICE_LABELS = {
    maids: "For Attendants",
    valets: "For Valets",
    bellmen: "For Bell Desk",
    airbnb: "For Airbnb",
  };

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.userDetails);

  const handleDownloadDocument = (fileId) => {
    if (!fileId) {
      message.warning("This documnet is unavailable");
      return;
    }
    const link = `https://drive.google.com/uc?export=download&id=${fileId}`;
    window.location.href = link;
  };

  const handleOpenLink = (link) => {
    window.open(link, "_blank");
  };

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      if (user.isAdmin) {
        setPermissions({
          viewAttendants: user.services?.maids.enabled || false,
          viewValets: user.services?.valets.enabled || false,
          viewBellmans: user.services?.bellmen.enabled || false,
          viewAirbnb: user.services?.airbnb.enabled || false,
        });
      } else if (user.isAdmin === false) {
        setPermissions({
          viewAttendants: user.roles.permissions.viewAttendants || false,
          viewValets: user.roles.permissions.viewValets || false,
          viewBellmans: user.roles.permissions.viewBellmans || false,
          viewAirbnb: user.roles.permissions.viewAirbnb || false,
        });
      }
    }
  }, [user]);

  const enabledServiceKeys = useMemo(() => {
    if (!user?.services) return [];
    return Object.entries(user.services)
      .filter(([key, cfg]) => cfg?.enabled) // only enabled
      .map(([key]) => key);
  }, [user?.services]);

  if (!user) return null;

  return (
    <>
      {user ? (
        <Row className="m-0 p-4">
          <Col>
            <h4 className="text-center text-primary fw-bold">Chatbots</h4>
            <Row className="my-3 justify-content-center">
              {enabledServiceKeys.map((serviceKey) => {
                const show =
                  (serviceKey === "maids" && permissions.viewAttendants) ||
                  (serviceKey === "valets" && permissions.viewValets) ||
                  (serviceKey === "bellmen" && permissions.viewBellmans) ||
                  (serviceKey === "airbnb" && permissions.viewAirbnb);

                if (!show) return null;

                return (
                  <Col xs={12} sm={6} md={4} key={serviceKey}>
                    <QrCodeCard
                      user={user}
                      serviceKey={serviceKey}
                      title={SERVICE_LABELS[serviceKey] || serviceKey}
                    />
                  </Col>
                );
              })}
            </Row>

            {/*  Valet locatons QR codes */}
            <Row className="my-3">
              {Array.isArray(user?.valetLocations) &&
                user.valetLocations.map((loc) => (
                  <Col xs={12} sm={6} md={4} lg={3} key={loc._id}>
                    <QrCodeCard
                      user={user}
                      serviceKey="valets"
                      title={`${loc?.locationName || "Location"}`}
                      locationId={loc._id}
                      overrideQr={loc?.qrCode}
                      overrideBotRef={loc?.botRef}
                    />
                  </Col>
                ))}
            </Row>

            <h4 className="text-center text-primary fw-bold">
              Download helping documents
            </h4>
            <Row className="my-5">
              <Col>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <FontAwesomeIcon
                          icon={faFolderOpen}
                          className="fs-5 text-primary"
                        />
                      </Col>
                      <Col md={6}>How to onboard your hotel</Col>
                      <Col xs="auto" className="ms-auto">
                        <Button
                          onClick={() => {
                            handleDownloadDocument(
                              "1kufslCghAXCtgcogSnE-lvGSXcetSu3A"
                            );
                          }}
                          variant="outline-success"
                          className="rounded-4 border-0 fs-5"
                        >
                          <FontAwesomeIcon icon={faDownload} className="" />
                        </Button>

                        <Button
                          variant="outline-primary"
                          className="rounded-4 border-0 fs-5"
                          onClick={() => {
                            const link = user.model?.b2b
                              ? ONBOARD_YOUR_HOTEL_B2B
                              : ONBOARD_YOUR_HOTEL_B2C;
                            handleOpenLink(link);
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            className=""
                          />
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <hr className="m-0 p-0" />
                  <ListGroup.Item>
                    <Row className="align-items-center">
                      <Col xs="auto">
                        <FontAwesomeIcon
                          icon={faFolderOpen}
                          className="fs-5 text-primary"
                        />
                      </Col>
                      <Col md={6}>How to onboard your team</Col>
                      <Col xs="auto" className="ms-auto">
                        <Button
                          variant="outline-success"
                          className="rounded-4 border-0 fs-5"
                          onClick={() => {
                            handleDownloadDocument(
                              "1nSl617jXpGUNj8px8_HwDYnvWod6zhvd"
                            );
                          }}
                        >
                          <FontAwesomeIcon icon={faDownload} className="" />
                        </Button>
                        <Button
                          variant="outline-primary"
                          className="rounded-4 border-0 fs-5"
                          onClick={() => {
                            const link = user.model?.b2b
                              ? ONBOARD_YOUR_TEAM_B2B
                              : ONBOARD_YOUR_TEAM_B2C;
                            handleOpenLink(link);
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            className=""
                          />
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <hr className="m-0 p-0" />
                  {permissions.viewAttendants && (
                    <>
                      <ListGroup.Item>
                        <Row className="align-items-center">
                          <Col xs="auto">
                            <FontAwesomeIcon
                              icon={faFolderOpen}
                              className="fs-5 text-primary"
                            />
                          </Col>
                          <Col md={6}>Starter guide for room attendants</Col>
                          <Col xs="auto" className="ms-auto">
                            <Button
                              variant="outline-success"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                handleDownloadDocument(
                                  "10Bs_NEAkYuqEK6XCCVTD-D6s4bD1UGkk"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faDownload} className="" />
                            </Button>
                            <Button
                              variant="outline-primary"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                const link = user.model?.b2b
                                  ? STARTER_GUIDE_ATTENDANTS_B2C
                                  : STARTER_GUIDE_ATTENDANTS_B2C;
                                handleOpenLink(link);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className=""
                              />
                            </Button>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <hr className="m-0 p-0" />
                    </>
                  )}
                  {permissions.viewValets && (
                    <>
                      <ListGroup.Item>
                        <Row className="align-items-center">
                          <Col xs="auto">
                            <FontAwesomeIcon
                              icon={faFolderOpen}
                              className="fs-5 text-primary"
                            />
                          </Col>
                          <Col md={6}>Starter guide for valets</Col>
                          <Col xs="auto" className="ms-auto">
                            <Button
                              variant="outline-success"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                handleDownloadDocument(
                                  "1KwxlfM-Yjq3d3G-hiKEup0z8AO42VrSC"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faDownload} className="" />
                            </Button>
                            <Button
                              variant="outline-primary"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                const link = user.model?.b2b
                                  ? STARTER_GUIDE_VALET_B2C
                                  : STARTER_GUIDE_VALET_B2C;
                                handleOpenLink(link);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className=""
                              />
                            </Button>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <hr className="m-0 p-0" />
                    </>
                  )}
                  {permissions.viewBellmans && (
                    <>
                      <ListGroup.Item>
                        <Row className="align-items-center">
                          <Col xs="auto">
                            <FontAwesomeIcon
                              icon={faFolderOpen}
                              className="fs-5 text-primary"
                            />
                          </Col>
                          <Col md={6}>Starter guide for bell desk</Col>
                          <Col xs="auto" className="ms-auto">
                            <Button
                              variant="outline-success"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                handleDownloadDocument(
                                  "1zk71xkuhA8TklOHK9cLOc2Xl7KDaqCmC"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faDownload} className="" />
                            </Button>
                            <Button
                              variant="outline-primary"
                              className="rounded-4 border-0 fs-5"
                              onClick={() => {
                                const link = user.model?.b2b
                                  ? STARTER_GUIDE_BELLMEN_B2C
                                  : STARTER_GUIDE_BELLMEN_B2C;
                                handleOpenLink(link);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faArrowUpRightFromSquare}
                                className=""
                              />
                            </Button>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <hr className="m-0 p-0" />
                    </>
                  )}
                </ListGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </>
  );
};

export default Documents;
